import Vue from 'vue'
import { MEDICAL_INSURENCE_PARTICULAR } from './constants'

export function setCompany (state, data) {
  if (data) {
    state.company = data
  } else {
    state.company = null
  }
}

export function setCompanies (state, data) {
  if (data) {
    state.companies = data
  } else {
    state.companies = null
  }
}

export function setAttendances (state, data) {
  if (data) {
    state.attendances = data
  } else {
    state.attendances = null
  }
}

export function setMedicalInsurances (state, data) {
  if (data) {
    state.medicalInsurances = data
  } else {
    state.medicalInsurances = null
  }
}

export function setFullDaysOrNotAvaible (state, data) {
  if (data) {
    state.fullDaysOrNotAvaible = data
  } else {
    state.fullDaysOrNotAvaible = null
  }
}

export function setSpecialties (state, data) {
  if (data) {
    state.specialties = data
  } else {
    state.specialties = null
  }
}

export function setProfessionals (state, data) {
  if (data) {
    state.professionals = data
  } else {
    state.professionals = null
  }
}

export function setFilter (state, data) {
  if (data) {
    Object.keys(data)
      .forEach(k => {
        Vue.set(state.filter, k, data[k]);
      });
  } else {
    state.filter = {}
  }
}

export function setSelected (state, data) {
  if (data) {
    state.selected = { ...data }
    saveSelected(state.selected)
  } else {
    state.selected = {}
    localStorage.removeItem('selectedBooking');
  }
}

export function setBookingStep (state, step) {
  state.bookingStep = step
}

export function setChoosedTime (state, { time }) {
  state.selected.choosedTime = time
  saveSelected(state.selected)
}

export function incrementStep (state, { date, tenant, profissional, atendimento, medicalInsurance }) {

  state.bookingStep++

  medicalInsurance = medicalInsurance ? medicalInsurance : MEDICAL_INSURENCE_PARTICULAR

  if (atendimento) {
    state.selected = {
      date,
      tenant,
      professional: profissional,
      medicalInsurance,
      attendance: atendimento,
      schedules: atendimento.horarios
    }
    saveSelected(state.selected)
  }
}

export function decrementStep (state, { keepAtendimento }) {
  state.bookingStep--

  if (!keepAtendimento) {
    state.selected = {}
  }

  saveSelected(state.selected)
}


export function setHorarios (state, { date, profissional, atendimento, horarios }) {

  const indexProfissional = getIndex(state, date, profissional)
  const indexAtendimento = state.attendances[date][indexProfissional].atendimentos.findIndex(e => e.codigo == atendimento.codigo)

  state.attendances[date][indexProfissional].atendimentos[indexAtendimento].horarios = horarios

  state.selected.schedules = horarios
  saveSelected(state.selected)
}


export function initialiseStore (state) {

  if (localStorage.getItem('selectedBooking')) {
    setSelected(state, JSON.parse(localStorage.getItem('selectedBooking')))
  }

}

function saveSelected (data) {
  localStorage.setItem('selectedBooking', JSON.stringify(data));
}


function getIndex (state, date, profissional) {
  return state.attendances[date].findIndex(e => e.profissional.codigo == profissional.codigo)
}
